import React, { useState } from 'react';
import { IconEmma } from 'design-system/icons/IconEmma';
import IconTransaction from 'design-system/icons/IconTransaction';
import { IconSettingsBold } from 'design-system/icons/IconSettingsBold';
import useColors from 'hooks/useColors';
import { AssetFilterCategory } from '../types';
import FilterWatchListItem from './FilterWatchListItem';
const FilterAssetsModalContent = ({ hideModal, selectedFiler, onSelectFilter, }) => {
    const [selectedValue, setSelectedValue] = useState(selectedFiler);
    const onFilterPress = (filter) => () => {
        setSelectedValue(filter);
        onSelectFilter(filter);
        hideModal();
    };
    const colors = useColors();
    return (<>
      <FilterWatchListItem title="Alphabetical" onPress={onFilterPress(AssetFilterCategory.NAME)} icon={<IconEmma gradientColors={colors.gradients.skyBlue.colors}/>} isSelected={selectedValue === AssetFilterCategory.NAME}/>
      <FilterWatchListItem title="Symbol" icon={<IconSettingsBold />} onPress={onFilterPress(AssetFilterCategory.SYMBOL)} isSelected={selectedValue === AssetFilterCategory.SYMBOL}/>
      <FilterWatchListItem title="Price" icon={<IconTransaction />} onPress={onFilterPress(AssetFilterCategory.PRICE)} isSelected={selectedValue === AssetFilterCategory.PRICE}/>
    </>);
};
export default FilterAssetsModalContent;
